<div class="container">
<div>Choose the market segments you’d like to fill out. <br> Select one or more relevant market segments:</div>
<div class="material-scope">
    <mat-form-field>
      <mat-label>Market Segment</mat-label>
      <mat-select [(ngModel)]="selectedMarket" multiple>
        <mat-option (click)="toggleAllMarketSelection()" [value]="'All'">All</mat-option>
        <mat-option *ngFor="let item of data.market" [value]="item" (click)="tosslePerOneMarket()">{{ item }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  </div>
<mat-dialog-actions style="display: flex; justify-content: center; gap: 10px;">
  <button class="btn" mat-dialog-close style="background-color: #e1ecf4; color: #174ea6; border: 1px solid #b3d3ea;">
    Cancel
  </button>
  <button class="btn" style="margin-left: 0;" [mat-dialog-close]="selectedMarket">
    Continue
  </button>
</mat-dialog-actions>
